import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "alert-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  return _ctx.question ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['answer-validation-alert', {
      'success': _ctx.answersValidationState,
      'failure': !_ctx.answersValidationState
    }])
  }, [_createVNode(_component_icon, {
    icon: _ctx.answersValidationState ? 'check-circle-outline' : 'alert-circle-outline',
    class: "alert-icon"
  }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.answersValidationState ? _ctx.$t('view.speach.simpleQuiz.goodAnswerMsg', {
    count: _ctx.shouldDisplayValidationMsgInPlural(_ctx.question) ? 0 : 1
  }) : _ctx.$t('view.speach.simpleQuiz.incorrectAnswerMsg', {
    count: _ctx.shouldDisplayValidationMsgInPlural(_ctx.question) ? 0 : 1
  })), 1)], 2)) : _createCommentVNode("", true);
}